import Button from "@components/Button";
import Link from "@components/Link";
import styles from "./Information.module.scss";
import cx from "classnames";
// import { useTranslationContext } from "@providers/TranslationProvider";
import { useBookingContext } from "@providers/BookingProvider";
import { usePageContext } from "@providers/PageProvider";
import { offerPage } from "@utils/helper";
import _ from "lodash";
const View = () => {
  // const { i18n } = useTranslationContext();
  const { booking } = useBookingContext();
  const { pageData, hotel } = usePageContext();
  const information = offerPage.formatInformation(pageData);
  const button = _.get(information, "button");
  const handler = {
    book: () => {
      const hasHref = !!_.get(button, "href") && _.get(button, "href") !== "#";
      if (!hasHref) {
        booking.open({ hotel });
      }
    },
  };
  return (
    <section data-scroll-section className={styles.section}>
      <div className={cx("ama-section-title", styles.title)}>
        {_.get(information, "title")}
      </div>
      <div className={styles.desc}>{_.get(information, "description")}</div>
      <Link href={_.get(button, "href", "#")}>
        <Button
          onClick={handler.book}
          className={styles.button}
          label={
            <>
              <span className="xs:hidden sm:block">
                {_.get(button, "label")}
              </span>
              <span className="xs:block sm:hidden">
                {_.get(button, "label")}
              </span>
            </>
          }
          color="white"
        />
      </Link>
    </section>
  );
};
export default View;
